import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent implements OnInit {
  @Input() text: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
